export var stripePublishableKey = 'pk_live_HxKcSry2nJVFQD4jNLAGlWFx'